import { CHAINS } from 'config/chains'
import { PUBLIC_NODES } from 'config/nodes'
import memoize from 'lodash/memoize'
import { configureChains, createConfig, createStorage } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { BybitWalletConnector } from '@pancakeswap/wagmi/connectors/bybitWallet'
import { BitgetWalletConnector } from '@pancakeswap/wagmi/connectors/bitgetWallet'
import { OkxWalletConnector } from '@pancakeswap/wagmi/connectors/okxWallet'
import { ParticleConnector } from '@pancakeswap/wagmi/connectors/particle'
import { getBinanceWalletProvider } from '@pancakeswap/wagmi/connectors/binanceWallet'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'

// get most configs chain nodes length
const mostNodesConfig = Object.values(PUBLIC_NODES).reduce((prev, cur) => {
  return cur.length > prev ? cur.length : prev
}, 0)

export const { publicClient, chains } = configureChains(
  CHAINS,
  Array.from({ length: mostNodesConfig })
    .map((_, i) => i)
    .map((i) => {
      return jsonRpcProvider({
        rpc: (chain) => {
          if (process.env.NODE_ENV === 'test' && chain.id === mainnet.id && i === 0) {
            return { http: 'https://cloudflare-eth.com' }
          }
          return PUBLIC_NODES[chain.id]?.[i]
            ? {
                http: PUBLIC_NODES[chain.id][i],
              }
            : null
        },
      })
    }),
  {
    batch: {
      multicall: {
        batchSize: 512,
      },
    },
  },
)

export const injectedConnector = new InjectedConnector({
  chains,
  options: {
    shimDisconnect: true,
  },
})

// export const coinbaseConnector = new CoinbaseWalletConnector({
//   chains,
//   options: {
//     appName: 'Agni',
//     appLogoUrl: 'https://pancakeswap.com/logo.png',
//   },
// })

export const walletConnectConnector = new WalletConnectConnector({
  chains,
  options: {
    projectId: '776b1f4d6d8a05445ada51f0764b349e',
    showQrModal: true,
    qrModalOptions: {
      themeVariables: {
        // @ts-ignore
        '--w3m-z-index': 999999,
      },
    },
  },
})

// export const walletConnectNoQrCodeConnector = new WalletConnectLegacyConnector({
//   chains,
//   options: {
//     qrcode: false,
//   },
// })

export const metaMaskConnector = new MetaMaskConnector({
  chains,
  options: {
    shimDisconnect: true,
  },
})

// const bloctoConnector = new BloctoConnector({
//   chains,
//   options: {
//     defaultChainId: 56,
//     appId: 'e2f2f0cd-3ceb-4dec-b293-bb555f2ed5af',
//   },
// })
//
// const ledgerConnector = new LedgerConnector({
//   chains,
// })

export const bscConnector = getBinanceWalletProvider({ chains }) as any

// export const trustWalletConnector = new TrustWalletConnector({
//   chains,
//   options: {
//     shimDisconnect: false,
//     shimChainChangedDisconnect: true,
//   },
// })
export const bybitWalletConnector = new BybitWalletConnector({
  chains,
  options: {
    shimDisconnect: true,
    shimChainChangedDisconnect: true,
  },
})
export const bitgetWalletConnector = new BitgetWalletConnector({
  chains,
  options: {
    shimDisconnect: true,
    shimChainChangedDisconnect: true,
  },
})
export const okxWalletConnector = new OkxWalletConnector({
  chains,
  options: {
    shimDisconnect: true,
    shimChainChangedDisconnect: false,
  },
})
export const particleConnector = new ParticleConnector({
  chainInfo: {
    id: CHAINS[0].id,
    name: CHAINS[0].name,
  },
  chains,
  options: {
    shimDisconnect: false,
    shimChainChangedDisconnect: true,
  },
})

export const noopStorage = {
  getItem: (_key) => '',
  setItem: (_key, _value) => null,
  removeItem: (_key) => null,
}

export const wagmiConfig = createConfig({
  storage: createStorage({
    storage: typeof window !== 'undefined' ? window.localStorage : noopStorage,
    key: 'wagmi_v1.1',
  }),
  autoConnect: false,
  publicClient,
  connectors: [
    metaMaskConnector,
    injectedConnector,
    walletConnectConnector,
    bybitWalletConnector,
    bitgetWalletConnector,
    okxWalletConnector,
    bscConnector,
    particleConnector,
  ],
})

export const CHAIN_IDS = chains.map((c) => c.id)

export const isChainSupported = memoize((chainId: number) => (CHAIN_IDS as number[]).includes(chainId))
export const isChainTestnet = memoize((chainId: number) => {
  const found = chains.find((c) => c.id === chainId)
  return found ? 'testnet' in found : false
})
